var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('templatePublicComponent',[_c('div',[_c('h3',[_vm._v("Événements :")]),_vm._v(" "),_c('div',{staticClass:"content"},_vm._l((_vm.eventitems),function(item){return _c('div',{key:item.ID},[_c('h6',[_vm._v(_vm._s(_vm._f("formatDateTime")(item.Date)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.Description))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c3fb7da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Evenements.vue
// module id = null
// module chunks = 